import { createContext } from 'react';
import type { BalanceTheme } from '@balance-web/theme';
import type { ResponsiveProp } from '@balance-web/core';

export type PageBlockContextShape = {
  size?: ResponsiveProp<keyof BalanceTheme['breakpoints']>;
};
export const PageBlockContext = createContext<PageBlockContextShape>({
  size: 'large',
});
